import React from 'react';
import PropTypes from 'prop-types';
import './WarningMessage.css';

const WarningMessage = ({ children, icon = 'warning', ...rest }) => (
  <span className="warning-message" {...rest}>
    <i className="material-icons">{icon}</i>
    <span>{children}</span>
  </span>
);

WarningMessage.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
};

export default WarningMessage;



// WEBPACK FOOTER //
// ./src/components/WarningMessage/WarningMessage.jsx